import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttachImageIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M13.3333 2H2.66663C1.56663 2 0.666626 2.9 0.666626 4V12C0.666626 13.1 1.56663 14 2.66663 14H13.3333C14.4333 14 15.3333 13.1 15.3333 12V4C15.3333 2.9 14.4333 2 13.3333 2ZM2.66663 3.33333H13.3333C13.7 3.33333 14 3.63333 14 4V8.57333L11.0933 6.15333C10.8466 5.94667 10.4866 5.94667 10.24 6.15333L7.19996 8.68667L5.75996 7.48667C5.51329 7.28 5.15329 7.28 4.90663 7.48667L1.99996 9.90667V4C1.99996 3.63333 2.29996 3.33333 2.66663 3.33333ZM13.3333 12.6667H2.66663C2.29996 12.6667 1.99996 12.3667 1.99996 12V11.6467L5.33329 8.86667L6.77329 10.0667C7.01996 10.2733 7.37996 10.2733 7.62663 10.0667L10.6666 7.53333L14 10.3133V12C14 12.3667 13.7 12.6667 13.3333 12.6667Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttachImageIcon.displayName = 'AttachImageIcon';
